import {Table, Tbody, Td, Th, Thead, Tr} from "react-super-responsive-table";
import React, {useState} from "react";
import {Button} from "reactstrap";
import RemoveList from "../../../components/RemoveList/RemoveList";
import moment from "moment";
import EditTranslation from "./TranslationEdit";

const TranslationList = ({
                           lists,
                           disableService
                         }) => {
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [data, setData] = useState(null)
  const removeModalOpen = (service) => {
    setIsRemoveModalOpen(!isRemoveModalOpen)

    setData(service)
  }

  const tableRowElement = (lists) => {
    if (lists && lists.length) {
      return lists.map((listItem, i) => {
        if(listItem.translations) {
          return <Tr key={i}>
            <Td>{listItem.key}</Td>
            <Td>{listItem.typeOfService}</Td>
            <Td>{listItem.translations.en}</Td>
            <Td>{listItem.translations.bg}</Td>
            <Td>{listItem.active ? 'Да' : 'Не'}</Td>
            <Td>{moment(listItem.createdAt).format('DD-MM-YYYY')}</Td>
            <Td>
              <div className="button-items d-flex">

                <button
                  type="button"
                  className="btn btn-primary waves-effect waves-light"
                  onClick={() => {
                    setData(listItem);
                    setIsEditModalOpen(!isEditModalOpen)
                  }}
                >
                  <i className="bx bxs-edit font-size-16 align-middle"></i>
                </button>
                <Button color={listItem.active ? 'danger' : 'success'} className='ml-1'
                        onClick={() => removeModalOpen(listItem)}>{listItem.active ? <i
                  className="bx bxs-dislike font-size-16 align-middle"></i> : <i
                  className="bx bxs-like font-size-16 align-middle"></i>}</Button>
              </div>
            </Td>
          </Tr>
        }
        return null
      })
    }
  }

  return <div className="table-rep-plugin">
    <div className="table-responsive mb-0" data-pattern="priority-columns">
      <Table
        id="tech-companies-1"
        className="table table-striped table-bordered"
      >
        <Thead>
          <Tr>
            <Th data-priority="1">Ключ</Th>
            <Th data-priority="3">Тип</Th>
            <Th data-priority="3">Превод (EN)</Th>
            <Th data-priority="1">Превод (BG)</Th>
            <Th data-priority="3">Активно</Th>
            <Th data-priority="3">Създадено</Th>
            <Th data-priority="3">Действия</Th>
          </Tr>
        </Thead>
        <Tbody>{tableRowElement(lists)}</Tbody>
      </Table>
    </div>
    <RemoveList isRemoveModalOpen={isRemoveModalOpen}
                title={`Искаш ли да ${data?.active ? 'деактивираш' : 'активираш'} услугата?`}
                subTitle={data?.active ? 'Деактивирай' : 'Активирай'}
                data={data?._id}
                status={'DISABLE'}
                onCancel={() => setIsRemoveModalOpen(false)}
                onSubmit={(id) => {
                  disableService({id})
                  setIsRemoveModalOpen(false)
                }}/>
    {isEditModalOpen && <EditTranslation isEditTranslationModalOpen={isEditModalOpen} onCancel={() => setIsEditModalOpen(false)}
                     translation={data}/>}
  </div>
}

export default TranslationList
